<h1 mat-dialog-title i18n>Add Document</h1>
<div>
  <div>
    <p i18n>To add a new document, complete the form below then click Submit.</p>
    <form #documentForm="ngForm" (ngSubmit)="addDocument(documentForm)">
      <div class="form-group row">
        <label for="quoteNote_Text" class="col-sm-3 col-form-label" i18n>Description</label>
        <div class="col-sm-9">
          <textarea #documentNote name="quoteNote_Text" id="quoteNote_Text"
                    [(ngModel)]="data.quoteNote_Text" #quoteNote_Text="ngModel"
                    class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <label for="note" class="col-sm-3 col-form-label" i18n>Attachment</label>
        <div class="col-sm-9">
          <div class="custom-file">
            <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile"></app-file-upload>
            {{data.quoteNote_Attachment}}
          </div>
        </div>
      </div>
      <div [hidden]="!documentForm.submitted || documentForm.valid"
           class="alert alert-danger" i18n>Validation issues encountered</div>
      <div class="row">
        <div *ngIf="!isRequesting">
          <button type="submit" class="btn btn-bidit-submit mr-1" cdkFocusInitial i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </form>
  </div>
</div>
